<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/price_bundles/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  data() {
    return {
      formRoute: route('api.v1.price_bundles.store'),
      redirectRoute: route('price_bundles.index'),
      stayOnPageRedirect: route('price_bundles.edit', {price_bundle: '_id_'}),
    }
  },
}
</script>

<template>
  <App title="Kortingsbundel toevoegen">
    <form class="mb-4" id="priceBundleForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="priceBundleForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>